export default {
  prospectPage: 'h-full overflow-y-auto flex flex-col',
  changeViewText: 'text-[#1B4960]! font-medium! pb-2 text-sm!',
  changeViewIcon: 'text-md!',
  activeView: 'bg-[#1B4960]! text-white!',
  matchingCustomersContainer:
    'absolute! bg-white! min-w-[250px]!  border-[#1B4960]! rounded-md! z-10! max-h-[500px]! overflow-y-auto! shadow-md!',
  matchingCustomersText: 'text-base! font-medium!  bg-transparent! p-2!',
  matchingCustomersName: 'break-all!    text-sm!',
  matchingCustomersStatus: 'text-sm! font-semibold!',
  sortingIconButton: 'bg-[#1B4960]! text-white!',
  searchBtn: 'w-fit! h-auto!',
  followUpText: 'text-[#1B4960]! font-medium! pb-1',
  tabStyle:
    ' flex items-center justify-center rounded-t-lg border border-gray-300 text-center small-netbook:h-fit!',
  tabContainer: 'ml-4 items-end ',
  activeTab: 'bg-[#ffe8b7]',
  tableViewGrid: 'ag-theme-alpine h-[calc(100vh-455px)]! min-h-[350px]!',
  activeCustomerLookUpText: 'text-[#1B4960]! font-medium!',
};
